import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { systemVersionsRouting } from './system-versions.routing';
import { SharedModule } from '../../core/shared/shared.module';
import { SystemVersionsComponent } from './system-versions-header/system-versions.component';
import { SystemVersionComponent } from './system-version/system-version.component';
import { SystemVersionElementsComponent } from './system-version-elements/system-version-elements.component';
import { SystemVersionRest } from './system-versions.rest';
import { LoginRest } from '../../login/login.rest';
import { MatIconModule } from '@angular/material';
import { DictionaryRest } from '../../dictionaries/dictionary/dictionary.rest';


@NgModule({
  imports: [CommonModule, systemVersionsRouting, SharedModule ],
  declarations: [SystemVersionsComponent, SystemVersionElementsComponent, SystemVersionComponent],
  exports: [SystemVersionsComponent, SystemVersionElementsComponent, SystemVersionComponent, MatIconModule],
  providers : [SystemVersionRest, LoginRest, DictionaryRest]

})
export class SystemVersionsModule { }
